// @ts-nocheck

import animationData from "./CloudDisconnect.json";
import LottieAnimation from "../LottieAnimation";

const CloudDisconnect = props => (
  <LottieAnimation animationData={animationData} {...props} />
);

export default CloudDisconnect;
